export default __webpack_public_path__ + "static/media/oops-empty-error.75b3016e.svg";